// extracted by mini-css-extract-plugin
export default {"wrapper":"SzVpo3","title":"G2NXzx","icons":"vjurP9"};